<template>
	<!-- 支付弹框 -->
	<div class="modal-wrap">
        <div class="modal-content">
            <img v-if="showClose" src="@/assets/images/order-manage/ic_order_off.png" class="close-icon close-pay" @click="onCloseClick">
            <div class="modal">
                <!-- <div class="title">支付详情</div> -->
				<div class="pay-wrap">
					<p class="pay-tips" v-if='flag!="member"'>待支付订单超过15分钟未付款自动取消</p>
					<p class="pay-cash">￥<span>{{payPrice}}</span></p>
					<span class="pay-plan" v-if='flag!="member"'>保障计划：未成功订单随时退。</span>
					<img v-if='flag!="member"' src="@/assets/images/order-manage/ic_question.png" class="question" @click="isPayTips=true">
				</div>

				<ul class="type-wrap">
					<li class="info-wrap have-border">
						<span class="paylogo weixin">微信支付</span>
						<span class="select-mark" @click="payStyle=1" :class='payStyle==1?"done":"undone"'></span>
					</li>
					<li class="info-wrap have-border" v-if="!isAppend">
						<span class="paylogo wallet">钱包支付</span>
						<span class="balance" v-text='"余额￥"+availableBalance'></span>
						<span class="select-mark" @click="payStyle=2" :class='payStyle==2?"done":"undone"'></span>
						<span class="activity" @click="goToCharge"><span v-for='(item,index) in rechargeList' :key="index">充{{item.recharge_money | filterNum}}送{{item.recharge_amount | filterNum}}&nbsp;</span></span>
					</li>
				</ul>
				<div class="modal-submit" @click="payClick(payStyle)">确认付款</div>
            </div>
        </div>

		<div class="modal-wrap"  v-if="isPayTips">
		    <div class="modal-plan">
				<img v-if="showClose" src="@/assets/images/order-manage/ic_order_off.png" class="close-icon pay-img" @click="isPayTips=false">
				<div class="modal">
					<div class="order-detail order-content">
						<div class="title">保障计划</div>
						<div class="agree-text">
						   <p>1、订单处理周期为五天，超过处理时间，商家可以直接申请全额退还款项，系统审核后款项原路退回。</p>
						   <p>2、订单处理期间，订单状态为“处理中”，表示订单正在处理，商家无故中途撤单，按<span style="color: #4184F4;" @click="isAgreeMent=true">《用心淘下单协议》</span>只能退还50%支付款项，系统审核后款项原路退回。</p>
						   <p>3、订单处理期间，订单状态变更为“未解决”，表示订单未处理成功， 商家可以直接申请全额退款，系统审核后款项原路退回。</p>
						</div>
					</div>
				</div>
			</div>
		</div>

		<!-- 下单协议弹框 -->
		<show-agree-ment v-if="isAgreeMent" @close-modal="isAgreeMent=false"></show-agree-ment>
	</div>
</template>

<script>
	import ShowAgreeMent from '@/components/ShowAgreeMent'
	import {getMyWallet,getRechargeClassList} from '@/api/wallet'
    export default {
		data(){
			return{
				isAgreeMent:false,
				isPayTips:false,
				payStyle:1,				//支付方式标识
				availableBalance:"",
				rechargeList:[]
			}
		},
		props:{
			payPrice:{
				type: String,
			},

            showClose: {
                type: Boolean,
            },

			flag:{
				type: String,
			},
			isAppend:{
                type: Boolean,
				default:false,
			},
		},
        name: 'PayModal',

		filters:{
			filterNum(val){
				if(String(val).includes(".")){
					let index = String(val).indexOf(".")
					return String(val).slice(0,index)
				}else{
					return val
				}
			}
		},

		created(){
			this.getMyWallet();			//获取用户账户余额
			this.getRechargeClassList();
		},
        methods:{
            onCloseClick() {
                this.$emit('close-modal');
            },

            payClick(payStyle){
                this.$emit('payClick',payStyle);
            },

			goToCharge(){
				this.$emit('goToCharge');
			},

			async getMyWallet(){
				const { data, status } = await getMyWallet();
				if(status=="200"){
					this.availableBalance = data.available_balance
				}
			},

			//获取充值机奖励
			async getRechargeClassList(){
				const { data, status } = await getRechargeClassList();
				if (status !== 200) return
				if(data.char && data.char.length > 2){
					this.rechargeList = data.char.slice(0,2)
				}else{
					this.rechargeList = data.char
				}

			}
        },

		components: {
			ShowAgreeMent
		}
    };
</script>
<style lang="less" scoped>
    @import '~@/assets/styles/variable.less';
    @import '~@/assets/styles/handleMethods.less';
    @import '~@/assets/styles/reset.css';
	section{font-family:PingFangSC-Regular;font-weight:400;background:#F5F5F5}
    .modal-wrap {position: fixed;width: 100vw;height: 100%;top: 0;left: 0;background:rgba(0,0,0,0.6);display: flex;justify-content: center;align-items: center; z-index:12;}
    .close-icon {.w(12);.h(12); position: relative;.t(-105);.t(15);right: -7.64rem;top: 0.9rem;}
    .pay-img{top: 0.9rem;}
	.close-pay{right: -7.9rem;top: 0.8rem;}
	.modal{width: 320px;/* height: 327px; */background: #fff;margin: 0 auto;padding-bottom: 20px;}
    .title{padding: 12px 21px;/* background: url(../../assets/images/home/pic_right2_pitchon.png) no-repeat 93% center;background-size: 12px; */font-size:18px;font-family:PingFangSC-Medium;font-weight:500;color:rgba(51,51,51,1);text-align: center;border-bottom: 1px solid #E9E9E9}
	/* 新支付弹框 */
	.modal{width: 320px;background: #fff;margin: 0 auto;padding-bottom: 25px;}
	.title{padding: 12px 21px;font-size:18px;font-family:PingFangSC-Medium;font-weight:500;color:rgba(51,51,51,1);text-align: center;border-bottom: 1px solid #E9E9E9}
	.pay-wrap{width:320px;padding: 27px 0 18px 0;background:rgba(65,132,244,0.08);text-align:center;}
	.pay-tips{font-size:14px;font-family:PingFangSC-Regular,PingFang SC;font-weight:400;color:rgba(74,74,74,1);}
	.pay-cash{padding: 7px 0 5px 0;font-size:25px;font-family:PingFangSC-Semibold,PingFang SC;font-weight:600;color:rgba(20,20,20,1);}
	.pay-cash span{font-size:34px;font-family:PingFangSC-Semibold,PingFang SC;font-weight:600;color:rgba(20,20,20,1);}
	.pay-plan{display: inline-block;vertical-align: middle;font-size:13px;font-family:PingFangSC-Regular,PingFang SC;font-weight:400;color:rgba(174,174,174,1);}
	.question{width: 14px;height: 14px;display: inline-block;vertical-align: middle;}
	.info-wrap{background: #fff;padding-left: 28px;padding-right: 15px;display: -webkit-box;display: -ms-flexbox;display: flex;flex-wrap: wrap;justify-content: space-between;align-items: center}
	.type-wrap{padding: 0 10px}
	.have-border{border-bottom: 1px solid #E9E9E9;padding-left: 20px}
	.paylogo{padding: 18px 0 18px 28px;.f-s(15);font-family:PingFangSC-Regular;font-weight:400;color:rgba(20,20,20,1);}
	.weixin{background: url(../assets/images/order-manage/ic_home_wechat.png) no-repeat left center;background-size: 18px;}
	.wallet{flex: 1;background: url(../assets/images/order-manage/ic_home_star_money.png) no-repeat left center;background-size: 16.5px;}
	.select-mark{display: inline-block;width:17px;height:17px;margin-right: 5px;vertical-align: top;box-sizing: content-box}
	.done{background: url(../assets/images/home/pic_right2_pitchon.png) no-repeat center center;background-size:cover;}
	.undone{background: url(../assets/images/home/pic_right2_pitchoff.png) center center no-repeat;background-size: cover}
	.balance{margin-right: 6px;font-size:12px;font-family:PingFangSC-Regular,PingFang SC;font-weight:400;color:rgba(174,174,174,1);}
	.activity{padding:0 12px 0px 28px;margin-bottom: 6px;margin-top: -14px;font-size:13px;font-family:PingFangSC-Regular,PingFang SC;font-weight:400;color:rgba(255,134,48,1);background: url(../assets/images/home/ic_home_enter.png) no-repeat right center;background-size: 6px}
	.modal-submit{width:278px;height:40px;margin: 0 auto;margin-top: 25px;line-height:40px;border-radius:2px;font-size:18px;font-family:PingFangSC-Regular;font-weight:400;background:rgba(65,132,244,1);text-align: center;color:rgba(255,255,255,1);}

	//支付提示弹框
	.pt-img{height: 20px;margin-right: 8px;display: inline-block;vertical-align:middle}
	.link-wrap{font-size: 0;height: 1.38666667rem;margin: 0 15px;line-height: 1.38666667rem;border-bottom: 0.026667rem solid #EEEEEE;}
	.link{display: inline-block;vertical-align: middle;color:rgba(20,20,20,1);font-size: 15px;font-family: PingFangSC-Semibold,PingFang SC;font-weight: 600;color: rgba(51,51,51,1);}
	.agree-text{padding: 20px 14px 10px 14px}
	.agree-text p{font-size:14px;margin-bottom: 15px;line-height: 22px;font-family:PingFangSC-Regular,PingFang SC;font-weight:400;color:rgba(102,102,102,1);letter-spacing:1px;}

	.modal-plan .modal{height: 386px}
</style>
